import Button from "@components/button/button";
import { ButtonSize, buttonTheme } from "@components/button/button-constants";
import TopicflowIcon from "@components/topicflow-icon/topicflow-icon";

const ProfileTabEmptyState = ({
  title,
  body,
  buttonText,
  onButtonClick,
}: {
  title: string;
  body: string;
  buttonText?: string;
  onButtonClick?: () => void;
}) => (
  <div className="bg-gray-50 border border-gray-100 rounded-[10px] p-12 flex flex-col items-center text-center gap-4">
    <TopicflowIcon type="fileSearch" className="w-9 h-9 text-gray-400" />
    <div className="flex flex-col items-center gap-1">
      <div className="tf-header-base-light">{title}</div>
      <div className="tf-body-sm-light">{body}</div>
    </div>
    {buttonText && onButtonClick && (
      <Button
        theme={buttonTheme.primary}
        size={ButtonSize.large}
        text={buttonText}
        onClick={onButtonClick}
      />
    )}
  </div>
);

export default ProfileTabEmptyState;
